'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _helpers = require('../common/helpers');

var _storageKeys = require('../storageKeys');

var _queue = require('./queue');

var queue = _interopRequireWildcard(_queue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var serializedArray = JSON.stringify([]);

var create = exports.create = function create(_ref) {
  var getTempStorage = _ref.getTempStorage,
      setTempStorage = _ref.setTempStorage;

  var isInitialized = false;
  var eventQueue = queue.create();

  return {
    getIsInitialized: function getIsInitialized() {
      return isInitialized;
    },

    initialize: function initialize(_ref2) {
      var normalizeEvent = _ref2.normalizeEvent;

      try {
        var storedEvents = getTempStorage(_storageKeys.storageKey) || serializedArray;
        var parsedEvents = JSON.parse(storedEvents);

        if (parsedEvents && (0, _helpers.isArray)(parsedEvents)) {
          parsedEvents.forEach(function (event) {
            if (event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object') {
              eventQueue.enqueue(normalizeEvent(event));
            }
          });
        }

        isInitialized = true;
      } catch (err) {
        /* noOp */
      }
    },

    push: function push(event) {
      try {
        var storedEvents = getTempStorage(_storageKeys.storageKey) || serializedArray;
        var parsedEvents = JSON.parse(storedEvents);
        parsedEvents.push(event);
        setTempStorage(_storageKeys.storageKey, JSON.stringify(parsedEvents));
      } catch (err) {
        /* noOp */
      }

      eventQueue.enqueue(event);
    },

    flush: function flush() {
      var events = [];

      do {
        var event = eventQueue.dequeue();
        if (event) {
          events.unshift(event);
        }
      } while (eventQueue.peek());

      try {
        setTempStorage(_storageKeys.storageKey, serializedArray);
      } catch (err) {
        /* noOp */
      }

      return events;
    },

    peek: eventQueue.peek
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.76/js/eventPool/index.js
// module id = 395
// module chunks = 0